// Basics
import { Component, OnInit } from '@angular/core';

// Template
import { ThemeConstantService } from '../../../../shared/services/theme-constant.service';
import { TableService } from '../../../../shared/services/table.service';
import { AngularCsv } from 'angular7-csv/dist/Angular-csv'

// Filter
import {Filter} from '../../../../shared/model/filter.model';
import {FilterService} from '../../../../shared/services/filter.service';

// models
import {ProjectResultsDisplay} from '../../../../shared/model/projectResults.model';

// Services
import {ResultsService} from '../../../../shared/services/results.service';


@Component({
  selector: 'app-results-view',
  templateUrl: './results-view.component.html'
})
export class ResultsViewComponent implements OnInit {

  projectResults
  displayProjectResults
  themeColors = this.colorConfig.get().colors;
    blue = this.themeColors.blue;
    blueLight = this.themeColors.blueLight;
    cyan = this.themeColors.cyan;
    cyanLight = this.themeColors.cyanLight;
    gold = this.themeColors.gold;
    purple = this.themeColors.purple;
    purpleLight = this.themeColors.purpleLight;
    red = this.themeColors.red;
    transparent = this.themeColors.transparent

  csvOptions = {
    fieldSeparator: ';',
    quoteStrings: '"',
    decimalseparator: ',',
    showLabels: true,
    showTitle: true,
    //title: 'Your Holiday List :',
    useBom: true,
    noDownload: false,
    headers: ["Holiday ID", "Holiday Date", "Holiday Comment", "Holiday Status"]
  };

  constructor(private filterService : FilterService, 
  			      private colorConfig:ThemeConstantService,
  	          private tableSvc : TableService, 
  			      private projectResultsService : ResultsService,) { }

  ngOnInit() {

  	this.filterService.data
      .subscribe ((filtros : any) => {
          console.log(filtros)
          this.projectResultsService.getResults(filtros, "project")
          .subscribe((data : any) => {
             console.log(data)
             this.projectResults = data.data;
             this.displayProjectResults = data.data;
          }); 
      });

  }

  DownloadProjectResults() {
       let head = []
       for (var i = 0; i < this.projectResults.keys.length; ++i) {
         head.push(this.projectResults.keys[i]);
       }
       this.csvOptions.headers = head;
       new  AngularCsv(this.projectResults, "Project Results", this.csvOptions);
  }

  sort1(sortAttribute: any) {
        this.displayProjectResults = this.tableSvc.sort(sortAttribute, this.displayProjectResults);
        //console.log("sort has been finished")
  }

}
